export default __webpack_public_path__ + "static/media/icon.a544fd8c.png";